import type { CSSObject } from "@emotion/serialize";

import { Breakpoints } from "~/client/components/shared/ResponsiveContainer";

const smartphoneMax = `${Breakpoints.smartphone}px`;
const smallerPcMax = `${Breakpoints.smallerPc}px`;

export const smartphone = (styles: CSSObject): CSSObject => ({
  [`@media screen and (max-width: ${smartphoneMax})`]: styles,
});

export const smallerPc = (styles: CSSObject): CSSObject => ({
  [`@media screen and (max-width: ${smallerPcMax})`]: styles,
});

export const smallerPcOver = (styles: CSSObject): CSSObject => ({
  [`@media screen and (min-width: calc(${smallerPcMax} + 1px))`]: styles,
});

export const pc = (styles: CSSObject): CSSObject => ({
  [`@media screen and (min-width: calc(${smartphoneMax} + 1px))`]: styles,
});
